export default __webpack_public_path__ + "static/media/50k.83ef5a18.md";